export const parseCurrency = (value: string | number): number => {
  return Number(parseFloat(value.toString()).toFixed(2))
}
